import { render, staticRenderFns } from "./OauthLoading.vue?vue&type=template&id=05903c52&scoped=true"
import script from "./OauthLoading.vue?vue&type=script&lang=js"
export * from "./OauthLoading.vue?vue&type=script&lang=js"
import style0 from "./OauthLoading.vue?vue&type=style&index=0&id=05903c52&prod&scoped=true&lang=css"
import style1 from "./OauthLoading.vue?vue&type=style&index=1&id=05903c52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05903c52",
  null
  
)

export default component.exports